import { BillJobFileLocationDetails } from './index';

export class BillJobFile {
	public fileId: string;
	public fileName: string;
	public fileKey: string;
	public sessionId: string;
	public userId: string;
	public status: string;
	public errorMessage: string;
	public updatedAt: string | Date;
	public createdAt: string | Date;

	public result: {
		commodity?: string;
		unit?: string;
		documentType?: string;
		documentId?: string;
		statementDate?: string;
		issuer?: string;
		customerName?: string;
		// location details
		locations?: BillJobFileLocationDetails[];

		// when there is an error
		classification?: {
			confidence?: number;
			reasoning?: string;
			explanation?: string;
			docType?: string;
		};
		error?: string;
	};

	// internal use
	public s3Path?: string;
	public errorCount?: number;

	constructor(billJobFile?: BillJobFile) {
		Object.assign(this, billJobFile);

		this.errorCount = this.errorMessage ? this.errorMessage.split(';').length : this.result?.error ? 1 : 0;
		this.errorMessage = (this.errorMessage || this.result?.error) ?? '';
		this.s3Path = 's3://bill-reader-ai/' + this.fileKey;
		this.updatedAt = new Date(this.updatedAt);
		this.createdAt = new Date(this.createdAt);
	}
}
